import { render } from "./MainPanel.vue?vue&type=template&id=63d93f21"
import script from "./MainPanel.js?vue&type=script&lang=js"
export * from "./MainPanel.js?vue&type=script&lang=js"

import "./MainPanel.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/korean-handbook/korean-handbook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__